<footer class="site-footer">
  <div class="site-footer__container">
    <!-- Copyright + Logo -->
    <div class="site-footer__info">
      <a class="site-footer__logo" href="/" [attr.aria-label]="'footer.aria.logo' | translate">
        <img src="/favicon.png" alt="Clúster TIC Galicia" />
      </a>
      <p class="site-footer__copyright">
        {{ 'footer.copyright_text' | translate: { year: currentYear, brand: brandName } }}
      </p>
    </div>

    <!-- Links legales -->
    <nav class="site-footer__legal" [attr.aria-label]="'footer.aria.legal_links' | translate">
      @for (link of legalLinks; track trackByLabel($index, link)) {
        <a [href]="link.href">{{ link.label | translate }}</a>
      }
    </nav>

    <!-- Redes sociales -->
    <nav class="site-footer__social" [attr.aria-label]="'footer.aria.social_links' | translate">
      @for (link of socialLinks; track trackByIcon($index, link)) {
        <a [href]="link.href" target="_blank" rel="noopener noreferrer" [attr.aria-label]="link.ariaLabel">
          <img [src]="link.icon" [alt]="link.ariaLabel" width="24" height="24" />
        </a>
      }
    </nav>
  </div>
</footer>
